import {
  AconexMailMetadataModel as ApiAconexMailMetadataModel,
  AconexDocumentMetadataModel as ApiAconexDocumentMetadataModel,
} from '@/services/generated/api';
import { DocumentListItem } from '../document-list/document-list-models';

export enum AddEditDialogMode {
  Edit,
  Create,
  CreateForWorkflow,
}

export class AddEditDocumentDialogResult {
  public ok = false;
  public createdDocumentGid: string | null = null;
  public createdDocumentVersionGid: string | null = null;
  public document: DocumentListItem | null = null;
  constructor(params?: Partial<AddEditDocumentDialogResult>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AddEditDocumentDialogParams {
  public mode: AddEditDialogMode = AddEditDialogMode.Create;
  public documentGid: string | null = null;
  public context = '';
  public targetOrganisationGid = '';
  public addToOrganisation = false;
  public addToProjectGids: string[] = [];
  public addToContractGids: string[] = [];

  // only when doing an import of something from Aconex
  public aconexMail: ApiAconexMailMetadataModel | null = null;
  public aconexDocument: ApiAconexDocumentMetadataModel | null = null;
  public aconexProjectId: string | null = null;

  public validate() {
    let isValid = true;
    const isEdit = this.mode === AddEditDialogMode.Edit;
    const isCreate = this.mode === AddEditDialogMode.Create;
    const isCreateForWorkflow = this.mode === AddEditDialogMode.CreateForWorkflow;
    const isEitherCreate = isCreate || isCreateForWorkflow;
    // logic from ENG
    if (isEdit && !this.documentGid) {
      isValid = false;
      console.error(
        `invalid AddEditDocumentDialogParams: mode is ${AddEditDialogMode[this.mode]} but documentGid not supplied`,
      );
    } else if (!isEdit && this.documentGid) {
      console.warn(
        `invalid AddEditDocumentDialogParams: documentGid should not be supplied when mode is ${AddEditDialogMode[this.mode]
        }. It will be ignored.`,
      );
    }

    if (isEitherCreate && !this.context) {
      isValid = false;
      console.error(
        `invalid AddEditDocumentDialogParams: mode is ${AddEditDialogMode[this.mode]} but context not supplied`,
      );
    } else if (!isEitherCreate && this.context) {
      console.warn(
        `invalid AddEditDocumentDialogParams: context should not be supplied when mode is ${AddEditDialogMode[this.mode]
        }. It will be ignored.`,
      );
    }

    if (isEitherCreate && (this.aconexDocument || this.aconexMail) && !this.aconexProjectId) {
      isValid = false;
      console.error(
        `invalid AddEditDocumentDialogParams: mode is ${AddEditDialogMode[this.mode]
        } and an aconex mail or document were supplied but aconexProjectId not supplied`,
      );
    }
    if (!isEitherCreate && this.aconexProjectId) {
      console.warn(
        `invalid AddEditDocumentDialogParams: aconexProjectId should not be supplied when mode is ${AddEditDialogMode[this.mode]
        }. It will be ignored.`,
      );
    }
    if (isEitherCreate && !this.aconexDocument && !this.aconexMail && this.aconexProjectId) {
      console.warn(
        `invalid AddEditDocumentDialogParams: mode is ${AddEditDialogMode[this.mode]
        } and no aconex mail or document were supplied but aconexProjectId was supplied. It will be ignored.`,
      );
    }

    if (isCreate && !this.targetOrganisationGid) {
      isValid = false;
      console.error(
        // eslint-disable-next-line prettier/prettier
        `invalid AddEditDocumentDialogParams: mode is ${AddEditDialogMode[this.mode]
        } but targetOrganisationGid not supplied`,
      );
    }

    if (isEdit && !!this.aconexDocument) {
      console.warn(
        `invalid AddEditDocumentDialogParams: aconexDocument should not be supplied when mode is ${AddEditDialogMode[this.mode]
        }. It will be ignored`,
      );
    }
    if (isEdit && !!this.aconexMail) {
      console.warn(
        `invalid AddEditDocumentDialogParams: aconexMail should not be supplied when mode is ${AddEditDialogMode[this.mode]
        }. It will be ignored.`,
      );
    }
    if (isEitherCreate && this.aconexDocument && this.aconexMail) {
      isValid = false;
      console.error(
        `invalid AddEditDocumentDialogParams: aconexDocument and aconexMail cannot both be supplied when mode is ${AddEditDialogMode[this.mode]
        }`,
      );
    }
    return isValid;
  }

  constructor(params?: Partial<AddEditDocumentDialogParams>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AddEditDocumentDialog {
  public open!: (params: AddEditDocumentDialogParams) => Promise<AddEditDocumentDialogResult>;
}
